<template>
	<div>
		<ListHeaderComponent :background="background" :black="true">
			<span slot="title">{{title}}</span>
		</ListHeaderComponent>
		<div class="empty-filter"></div>

		<section v-if="!reset && !newPassword" class="reset">
			<h2>{{$t('reset.page.headline')}}</h2>
			<h3>{{$t('reset.page.subheadline')}}</h3>
		</section>

		<section v-if="!reset && newPassword" class="reset">
			<h2>{{$t('reset.page.passwordChanged')}}</h2>
			<h3>{{$t('reset.page.use')}}</h3>
		</section>

		<form v-if="reset && !newPassword" class="reset">
			<h2>{{$t('reset.page.set')}}</h2>
			<div class="reset__password">
				<input class="reset__input reset__input--password" type="password" :placeholder="$t('reset.page.newPass')">
				<input class="reset__input reset__input--password-confirmed" type="password" :placeholder="$t('reset.page.newPassConfirmation')">
				<span v-if="error" class="reset__error">{{ error }}</span>
				<button class="reset__btn" @click="setNewPassword($event)">{{$t('reset.page.button')}}</button>
			</div>
		</form>
		<ContactComponent></ContactComponent>
		<PartnersComponent></PartnersComponent>
	</div>
</template>

<script>
	import ListHeaderComponent from '@/components/ListHeaderComponent'
	import ContactComponent from '@/components/ContactComponent'
	import PartnersComponent from '@/components/PartnersComponent'
	import axios from 'axios'

	export default {
		components: {
			ListHeaderComponent,
			ContactComponent,
			PartnersComponent
		},
		data () {
			return {
				title: 'Activate Account',
				background: 'account',
				reset: false,
				newPassword: false,
				error: ''
			}
		},
		methods: {
			isTokenCorrect () {
				let activationToken = this.$route.query.token
				axios.get(`/api/user/reset-password/${ activationToken }`, {})
					.then(resp => {
						this.reset = true
					})
					.catch(err => {
						console.log(err)
					})
			},
			passwordValidation (password, confirmedPassword) {
				if (password === confirmedPassword) {
					return true
				} else {
					this.error = 'To hasło nie pasuje! Potwierdź hasło ponownie'
				}
			},
			setNewPassword (event) {
				event.preventDefault()
				let activationToken = this.$route.query.token
				const password = document.querySelector('.reset__input--password').value
				const confirmedPassword = document.querySelector('.reset__input--password-confirmed').value

				if (this.passwordValidation(password, confirmedPassword)) {
					let data = {
						new_password: password
					}
					axios.post(`/api/user/reset-password/${ activationToken }/`, data, {})
						.then(resp => {
							this.reset = false
							this.newPassword = true
						})
						.catch(error => {
							console.log(error.response)
							if (error.response.status === 400) {
								if (error.response.data.new_password) {
									this.error = error.response.data.new_password[0]
								}
							}
						})
				}
			}
		},
		created () {
			this.isTokenCorrect()
		}
	}
</script>

<style lang="scss" scoped>

	@import "../styles/variables.scss";

	.reset {
		padding: 60px 0;
		&__password {
			margin: 0 auto;
			display: flex;
			flex-flow: column;
			justify-content: space-between;
			align-items: center;
			margin: 0 auto;
		}
		&__input {
			width: 365px;
			height: 65px;
			background-color: $gray-input;
			padding-left: 25px;
			border: none;
			outline: none;
			margin: 10px 0;
		}
		&__btn {
			cursor: pointer;
			display: block;
			text-transform: uppercase;
			width: 100%;
			max-width: 365px;
			height: 50px;
			background-color: $black;
			color: #fff;
			font-family: $lato-bold;
			font-size: 16px;
			border: none;
			outline: none;
			text-decoration: none;
			letter-spacing: 0.05em;
			margin: 10px 0;
		}
		&__error {
			display: block;
			text-align: left;
			font-family: $lato;
			font-size: 12px;
			margin-bottom: 10px;
			color: darkred;
		}
	}

	.empty-filter {
		width: 100%;
		height: 35px;
		background-color: $gold-light;
	}

</style>



// WEBPACK FOOTER //
// src/views/ResetPassword.vue